import adminLayout from '../../../layouts/admin'
import store from '../../../store'

export default {
  path: 'admin',
  component: adminLayout,
  children: [
    {
      path: 'accountinfo',
      component: () => import('./accountinfo/accountinfo.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    },
    {
      path: 'crm',
      component: () => import('./crm/crm.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    },
    {
      path: 'department',
      component: () => import('./department/department.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    },
    {
      path: 'googlecontact',
      component: () => import('./googlecontact/googlecontact.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    },
    {
      path: 'outlookcontact',
      component: () => import('./outlookcontact/outlookcontact.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    },
    {
      path: 'member',
      component: () => import('./member/member.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    },
    {
      path: 'permission',
      component: () => import('./permission/permission.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    },
    {
      path: 'security',
      component: () => import('./security/security.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    },
    {
      path: 'createuser',
      component: () => import('./createuser/createuser.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    },
    {
      path: 'managecreator',
      component: () => import('./managecreator/managecreator.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    },
    {
      path: 'manageuser',
      component: () => import('./manageuser/manageuser.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    },
    {
      path: 'managedevice',
      component: () => import('./managedevice/managedevice.vue'),
      meta: {
        activeMenu: 'admin',
        auth: true
      }
    }
  ],
  beforeEnter: (to, from, next) => {
    const privilege_info = store.state.user?.user_info?.privilege_info
    if (!privilege_info) {
      next({ path: '/user/login', replace: true })
      return
    }
    if (privilege_info && privilege_info.show_manage == 'y') {
      next()
    } else {
      if (privilege_info.show_company_cardholder == 'y') {
        next({ path: '/card/view' })
      } else {
        next({ path: '/noPermission' })
      }
    }
  }
}
